import { lazy } from 'react';

/**
 * React.lazy for code a deploy may have replaced. Use it for every lazy import.
 *
 * A tab from before a deploy asks for chunk hashes the new deployment no longer
 * has. The vite:preloadError handler in main.jsx then reloads the page and
 * cancels the error, and a cancelled error makes Vite resolve the import to
 * `undefined` instead of rejecting. React.lazy would read `.default` of that and
 * throw "Cannot read properties of undefined (reading 'default')", which the
 * error boundary showed until the reload landed (#939). Here the component
 * stays suspended instead, until the reload replaces the page.
 *
 * An error the handler lets through (a second failure within 10 s) still
 * rejects, and the error boundary shows it.
 */
export default function lazyWithReload(load) {
  return lazy(() => load().then((module) => module ?? new Promise(() => {})));
}
